var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import { formatDate } from 'syf-component-library/helpers/dateValidation';
import { CustomTextField, ErrorIcon } from './subcomponents';
import { AddAuthUserInputType } from '../../../../typings';
import getTranslation from '../../../../helpers/get-translation';
import triggerManageCardHoldersAnalytics from '../../../../helpers/trigger-manage-card-holders-analytics';
import { INPUT_MISSING_DETAILS, PAGE_NAME } from '../../../../const/analytics';
import DateOfBirthInput from '../../DateOfBirthInput';
import AddUserLegalContent from '../../AddUserLegalContent';
var MAX_LENGTH_INPUT = 25;
var AuthorizedUserForm = function (_a) {
    var authorizedUserInputValuesState = _a.authorizedUserInputValuesState, handleBlur = _a.handleBlur, updateState = _a.updateState, isAddAuthUserSubmitted = _a.isAddAuthUserSubmitted;
    var _b = getTranslation(), firstNameHelpText = _b.firstNameHelpText, firstNamePlaceholder = _b.firstNamePlaceholder, lastNameHelpText = _b.lastNameHelpText, lastNamePlaceholder = _b.lastNamePlaceholder;
    var isSubmittedOrTouched = function (type) {
        return (isAddAuthUserSubmitted || authorizedUserInputValuesState[type].touched);
    };
    var firstNameError = (isSubmittedOrTouched(AddAuthUserInputType.authorizedUserFirstName) &&
        authorizedUserInputValuesState.authorizedUserFirstName.errorMessage) ||
        '';
    var lastNameError = (isSubmittedOrTouched(AddAuthUserInputType.authorizedUserLastName) &&
        authorizedUserInputValuesState.authorizedUserLastName.errorMessage) ||
        '';
    var birthDateError = (isSubmittedOrTouched(AddAuthUserInputType.authorizedUserBirthDate) &&
        authorizedUserInputValuesState.authorizedUserBirthDate.errorMessage) ||
        '';
    var hasError = Boolean(firstNameError || lastNameError || birthDateError);
    if (hasError) {
        triggerManageCardHoldersAnalytics({
            errorMessage: INPUT_MISSING_DETAILS,
            pageName: PAGE_NAME.ERROR
        });
    }
    else {
        triggerManageCardHoldersAnalytics({
            pageName: PAGE_NAME.ADDITION
        });
    }
    var handleInputChange = function (type, newValue) {
        var value = typeof newValue === 'string'
            ? newValue
            : newValue.target.value;
        if (type === AddAuthUserInputType.authorizedUserBirthDate &&
            authorizedUserInputValuesState[AddAuthUserInputType.authorizedUserBirthDate].value.length <= value.length) {
            updateState({
                type: type,
                value: formatDate(value)
            });
        }
        else {
            updateState({
                type: type,
                value: value
            });
        }
    };
    return (_jsxs("div", __assign({ "data-testid": "add-authorized-users-form", "data-private": true }, { children: [_jsx(CustomTextField, { id: "first-name", autoCapitalize: "none", name: "first-name", placeholder: firstNamePlaceholder, helpText: firstNameHelpText, maxLength: MAX_LENGTH_INPUT, error: firstNameError, type: "text", value: authorizedUserInputValuesState.authorizedUserFirstName.value, errorIcon: _jsx(ErrorIcon, {}), onChange: function (event) {
                    return handleInputChange(AddAuthUserInputType.authorizedUserFirstName, event);
                }, onBlur: function () {
                    return handleBlur({
                        type: AddAuthUserInputType.authorizedUserFirstName
                    });
                }, width: 100 }), _jsx(Stack, { size: "large" }), _jsx(CustomTextField, { id: "last-name", autoCapitalize: "none", name: "last-name", placeholder: lastNamePlaceholder, helpText: lastNameHelpText, maxLength: MAX_LENGTH_INPUT, error: lastNameError, type: "text", value: authorizedUserInputValuesState.authorizedUserLastName.value, errorIcon: _jsx(ErrorIcon, {}), onChange: function (event) {
                    return handleInputChange(AddAuthUserInputType.authorizedUserLastName, event);
                }, onBlur: function () {
                    return handleBlur({
                        type: AddAuthUserInputType.authorizedUserLastName
                    });
                }, width: 100 }), _jsx(Stack, { size: "large" }), _jsx(DateOfBirthInput, { dateValue: authorizedUserInputValuesState.authorizedUserBirthDate.value, handleOnChange: function (newValue) {
                    return handleInputChange(AddAuthUserInputType.authorizedUserBirthDate, newValue);
                }, handleOnBlur: function () {
                    return handleBlur({
                        type: AddAuthUserInputType.authorizedUserBirthDate
                    });
                }, error: birthDateError }), _jsx(AddUserLegalContent, {})] })));
};
export default AuthorizedUserForm;
